<template>
  <v-dialog v-model="dialog" persistent :max-width="maxWidth" hide-overlay content-class="bottom-right-info-dialog" :origin="`bottom right`">
    <v-card>
      <v-card-title class="headline" v-if="title">{{ title }}</v-card-title>
      <v-card-text><slot></slot></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          color="primary"
          elevation="0"
          @click="submit">
          {{submitText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BottomRightInfoDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    submitText: {
      type: String,
      default: 'Close'
    },
    maxWidth: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
    },
  },
  methods: {
    submit() {
      this.dialog = false
      this.$emit('submit')
    },
  }
}
</script>

<style lang="scss">
@import '@/styles/variables';
.bottom-right-info-dialog {
  margin-left: auto;
  margin-top: auto;
}
</style>